import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class DownloadService {
    constructor(private http: HttpClient) {}

    async downloadAndOpenDocument(
        url: string,
        type: string,
        fileName?: string
    ) {
        const response = await this.http
            .get(url, { responseType: 'arraybuffer', observe: 'response' })
            .toPromise();

        if (!fileName) {
            const [, unquotedFileName, , quotedFileName]: RegExpMatchArray =
                response.headers
                    .get('Content-Disposition')
                    .match(/filename[^;=\n]*=((['"])(.*?)\2|[^;\n]*)/) || [];
            fileName = quotedFileName || unquotedFileName || 'file';
        }

        const file = new File([response.body], fileName, { type });
        const fileUrl = URL.createObjectURL(file);
        const tempLink = document.createElement('a');
        tempLink.href = fileUrl;
        tempLink.setAttribute('download', fileName);
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/download/download.service.ts